// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1-30d","selects":"Documents_selects__1SYhN"};